module.exports = "<div fxLayout=\"row wrap\">\n  <div fxFlex class=\"flex-p\"> <h4>Search results...</h4></div>\n</div>"